import { ButtonC } from 'Common/Buttons';
import React, { useCallback, useEffect, useState } from 'react';
import InputC from 'Common/Inputs/index.tsx';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Axios from 'functions/Axios';
import {
  Addfolder,
  DELETE_MULTIPLE_ASSET,
  Editfolder,
  GET_FOLDER_COLORS,
  GET_INSIDE_FOLDER_DATA,
  ROUTED_INNNER_FOLDER_DATA,
  UPDATE_FOLDER_COLOR,
  getSingleFolder,
} from '../DAM_API/urls';
import close from '../../../assets/V2-images/close.svg';
import deleteicon from '../../../assets/V2-images/deleteicon.png';
import renameicon from '../../../assets/V2-images/renameicon.png';
import { Viewbutton } from 'Common/Viewbutton';
import Tabledata from '../Assets/tabledata';
import Uploadfile from '../Uploadfile';
import { Griddata } from '../Assets/griddata';
import SpinnerLoader from './../../SpinnerLoader';
import Nodatacomponent from 'components/Nodatacomponent';
import { toast } from 'react-toastify';
import { Deletemodel } from 'Common/Deletemodel';
import { Assitdata, selectRangeByUUID } from '../Assets/assitdata';
import shareicon from '../../../assets/V2-images/shareicon.png';
import { useDispatch } from 'react-redux';
import {
  SelectedAssetData,
  setInnerFolderDetails,
  setInsideFolderFolderData,
  setInsideFolderId,
  setOpenPopup,
  SetSelctedFoldersData,
} from 'actions/damActions';
import { DAM_SVG } from '../DamAssets';
import { useSelector } from 'react-redux';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import download from '../../../assets/V2-images/download.png';
import ShareAssetSection from '../Components/Featured/ShareAsset';
import MoveToAssetDesign from '../Components/Featured/MoveToAssetDesign';
import CommonThreeDotSvg from '../Components/CommonThreeDotSvg';
import FolderGridSecondVersion from '../Components/FolderGridSecondVersion';
import WordWrapEllipse from '../WordWrapEllipse';
import SelectionActions from '../Components/Featured/selectionActions';
import { useContainerRef } from 'context/ContainerRefContext';
import { useDownloadAssets } from 'context/DownloadAssetsContext';
import { MODULE_IDS, useHasAccess, USER_RIGHTS } from 'actions/userActions';
import { selectionColors } from '../Types';
import CommonTableDrived from '../Components/Featured/CommonTableDrived';
import { sortOptions } from '../Assets';

const Innerfolder = ({
  damfieldid,
  resethandleClick,
  isPoppedUp,
  HandleSave,
  showHeader = true,
  showFolders = true,
  showViewOptions = true,
  showImages = true,
  isUpload = true,
  stateData = [],
  assetsData = {
    folders: [],
    images: [],
  },
  selectedfolderid,
  setselectedfolderId,
  fromBrandAssets,
  trash,
}) => {
  const { startDownload } = useDownloadAssets();
  const [state, setstate] = useState(stateData);
  const [modal, setModal] = useState(false);
  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [upload, setupload] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [showbar, setshowbar] = useState(false);
  const [show, setshow] = useState(true);
  const [newfolder, setnewfolder] = useState();
  const [selectedView, setSelectedView] = useState('Masonry View');
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const toggle = () => {
    setActiveId();
    setModal(true);
  };
  const [loadedData, setLoaded] = useState(0);
  const [totalData, setTotal] = useState(0);
  const [disableDropBox, setDisableDropBox] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [files, setFiles] = useState([]);
  const [previewFlag, setPreviewFlag] = useState(false);
  const [folderId, setFolderId] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [deletemodal, setdeletemodal] = useState(false);
  const [currentModalFolderName, setCurrentModalFolderName] = useState('');
  const [supportWebp, setSupportWebp] = useState(false);
  const [sharelink, setsharelink] = useState(false);
  const [expiredate, setexpiredate] = useState();
  const [expitetime, setexpitetime] = useState();
  const [indexdata, setindexdata] = useState();
  const [passname, setpassname] = useState('');
  const [searchData, setSearchData] = useState('');
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [innerFolderData, setInnerFolderData] = useState([]);
  const [isSelfAdd , setIsSelf] = useState(false);
  const [activeId, setActiveId] = useState();
  const hasDAMAccess = useHasAccess();
  const hasDAMFullAccess = useHasAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess]);
  const { insideFolderFolderData, insideFolderId, selectedAssets, selectedFolders } = useSelector(
    (state) => state.dam,
  );
  const { UploadFiles } = useDownloadAssets();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const params = useParams();
  const location = useLocation();
  const [isExpiration, setIsExpiration] = useState(false);
  const [assetInfo, setAssetInfo] = useState({});
  const [emails, setEmails] = useState([]);
  const [Authenticated, setAuthenticated] = useState(false);
  const [responsedLink, setResponsedLink] = useState();
  const [error, setError] = useState({});
  const [movetoModal, setMovetoModal] = useState(false);
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [currentFolderDetails, setCurrentFolderDetails] = useState();
  const { containerRef: listInnerRef, setScrollHandler } = useContainerRef();
  const [isAvailableData, setisAvailableData] = useState(true);
  const [metaData, setMetaData] = useState({
    currentPage: 0,
    pageSize: 50,
  });
  const [openRightSection, setOpenRightSection] = useState(false);
  const { refreshRef } = useDownloadAssets();
  const [sorting, setSorting] = useState(sortOptions[0]);

  useEffect(() => {
    setFolderId?.(selectedfolderid?.[selectedfolderid.length - 1]);
  }, []);

  const closeBtn = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );
  const closeBtn1 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setAddToCollectionModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const AddInArray = (data, isdirect = false) => {
    var arr = state;
    arr.push(data);
    setstate(isdirect ? [data] : arr);
  };

  const [assets, setAssets] = useState(assetsData);

  const datashow = async () => {
    if (!showHeader || !damfieldid) return;
    setIsLoading(true);
    setTimeout(async () => {
      // + `${folderId}?pageNo=${metaData?.currentPage}&rowSize=50`
      const data = await Axios.get(
        getSingleFolder +
          `${damfieldid}?pageNo=${metaData?.currentPage}&rowSize=50&trash=${trash === true ? true : false}&order=${sorting?.value}`,
      );

      // const folderIds = subfolderData?.folders?.[0]?.subfolders?.map((folder) => folder?.id);

      //   const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);
      dispatch(setInsideFolderId(damfieldid));
      setIsLoading(false);
      AddInArray(data.data.data, true);
      dispatch(setInsideFolderFolderData(data.data.data));
      setAssets(data.data.data);
    }, 200);
  };

  const handleEmailChange = (emails) => {
    setEmails(emails);
  };
  const [images, setImages] = useState();
  const Imagedata = assets?.images?.map((value) => {
    return { src: value.fileThumbnail, width: value.fileWidth, height: value.fileHeight };
  });

  useEffect(() => {
    setImages(Imagedata);
  }, [assets]);

  const fetchSubfolders = async (id) => {
    if (!showHeader && !selectedfolderid.length > 0) return;

    if (!isAvailableData && metaData?.currentPage > 0) {
      return;
    }
    try {
      const response = await Axios.get(
        getSingleFolder +
          `${id}?pageNo=${metaData?.currentPage}&rowSize=50&trash=${trash === true ? true : false}&order=${sorting?.value}`,
      );
      const { folders, images, paginationDto } = response.data.data;

      console.log(folders, 'folders in fetchSubfolders');
      setIsSelf(folders?.[0]?.isSelf)

      setisAvailableData(metaData?.currentPage * 50 < paginationDto?.totalAmountOfElements);
      const subfoldersData = {
        folders: folders || [],
        images: images || [],
      };
      return subfoldersData;
    } catch (error) {
      console.error('Error fetching subfolders:', error);
      return { folders: [], images: [] };
    }
  };

  const handleClick = async (id) => {
    if (!selectedfolderid) {
      setSearchData('');

      const navigatevalue = location.pathname;
      const newPath = `${navigatevalue}/${id}`;
      navigate(newPath);
    } else {
      setselectedfolderId?.((prev) => (prev.includes(id) ? prev : [...prev, id]));
    }

    dispatch(setInsideFolderId(id));
  };

  console.log(selectedfolderid, 'Selected folderids inside inner folder');

  const handlenavigate = (index) => {
    setSearchData('');

    const splittedData = innerFolderData.slice(0, index + 1);
    const navigatedata = '/dam/v2/assets';
    // join all ids into a single path
    const fullPath = navigatedata + '/' + splittedData.map((item) => item.id).join('/');
    navigate(fullPath);
    // setAssets(state[index]);
    // setstate([...state.slice(0, index + 1)]);
  };

  const folderedit = async () => {
    try {
      const formData = new FormData();
      formData.append('folderId', selectedDamFieldId);
      formData.append('newFolderName', textvalue);
      const response = await Axios.post(Editfolder, formData);

      if (response.data.success) {
        datashow();
        getData();
        setAddToCollectionModal(false);
        toast.success(response?.data?.message ?? 'Folder Renamed Successfully');
      } else {
        // Handle error case
        setAddToCollectionModal(false);
        toast.error('Folder Rename Failed');
      }
    } catch (error) {
      // Handle error
    }
    setAddToCollectionModal(false);
    setshowbar(false);
  };

  const handledelette = async () => {
    try {
      setDeleteLoading(true);
      setTimeout(() => {
        setdeletemodal(false);
      }, 4000);
      const data = await Axios.post(DELETE_MULTIPLE_ASSET, {
        fileId: [],
        folderId: [selectedDamFieldId],
      });
      getData(true, 0);
      setDeleteLoading(false);
      setdeletemodal(false);
    } catch (err) {
      setDeleteLoading(false);
      setdeletemodal(false);
      console.error(err);
    }
  };

  const folderaddded = async () => {
    try {
      const formData = new FormData();
      formData.append('folderName', textvalue);
      formData.append('parentFolderId', newfolder || damfieldid);
      const response = await Axios.post(Addfolder, formData);
      if (response.data.success) {
        // Folder created successfully, fetch updated folder data
        datashow();
        getData();
        setModal(false);
        toast.success(response?.data?.message ?? 'Folder created successfully');
      } else {
        // Handle error case
        toast.error('Folder created  Failed');
      }
    } catch (error) {
      // Handle error
      toast.error(error.response.data.message);
    }
    // Close the modal
  };

  const handleChange = (evt) => {
    const { value } = evt.target;
    settextvalue(value);
  };
  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };

  const handleshow = (id) => {
    setshowbar(id === showbar ? null : id);
    setSelectedDamFieldId(id);
  };

  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const toggleupload = () => {
    setupload(true);
  };

  const closeBtn4 = (
    <img
      src={close}
      className="close"
      onClick={() => setupload(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const uploadFiles = async () => {
    setDisableDropBox(true);
    let data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append('files', files[i]?.videoThumb ? files[i]?.file : files[i]);
    }
    for (let i = 0; i < files.length; i++) {
      data.append('videoThumbnail', files[i]?.videoThumb ? files[i]?.videoThumb?.[0] : null);
    }

    data.append('folderId', folderId ?? damfieldid);

    try {
      const res = await UploadFiles(data, files.length);
    } catch (error) {
      console.error('Error uploading files:', error);
      // toast.error('Failed to upload files. Please try again.');
    } finally {
      // setDisableDropBox(false);
      datashow();
    }
    datashow();
    // setupload(false);
    setUploadPercentage(0);
  };

  const FolderselectAsset = (index) => {
    let newAssets = insideFolderFolderData?.images;
    newAssets[index].selected = !newAssets[index]?.selected;
    // setAssets([...newAssets]);
    setAssets({
      ...assets,
      images: newAssets,
    });
  };

  const handleshowdata = async (damFileId, index) => {
    setResponsedLink();
    setError({});
    setexpiredate();
    setexpitetime();
    setAssetInfo({});
    setEmails([]);
    setAuthenticated(true);
    setIsExpiration(false);
    setindexdata(index);
    setsharelink(!sharelink);
    setshowbar(false);
    setActiveId();
  };

  const Shareshowdata = (e) => {
    setActiveId();
    e.stopPropagation();
    toggleShareLink();
  };
  const toggleShareLink = () => {
    setsharelink(!sharelink);
  };

  const deletmodal = (folderName) => {
    setdeletemodal(true);
    setpassname(folderName);
  };

  const getData = async (isload = true, pageno) => {
    console.log(trash, 'trash in getdata');
    try {
      setIsLoading(isload);
      // const response = await Axios.post(
      //   `${GET_INSIDE_FOLDER_DATA}?assetId=${damfieldid}&searchKeyword=${searchData}&forWhich=folder`,
      // );
      const folderId = getLastSegment(location?.pathname);
      let response;
      if (!searchData) {
        response = await Axios.get(
          getSingleFolder +
            `${folderId}?pageNo=${pageno ? pageno : metaData?.currentPage}&rowSize=50&trash=${trash === true ? true : false}&order=${sorting?.value}`,
        );
      } else {
        if (searchData?.length > 0 && searchData?.length < 3) {
          setIsLoading(false);
          return;
        }
        response = await Axios.post(GET_INSIDE_FOLDER_DATA, {
          searchKeyword: searchData,
          ...(folderId && {
            parentFolderId: folderId,
            trash: trash === true ? true : false,
          }),
        });
      }

      // console.log(response?.data?.data?.folders?.[0]?.subfolders, 'response line no 601');

      const folderIds = response?.data?.data?.folders?.[0]?.subfolders?.map((folder) => folder?.id);

      const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);
      // const _combine_data =
      //   metaData?.currentPage > 0 || metaData?.isScrolling
      //     ? [...selectedAssets, ...subfolderData?.images]
      //     : subfolderData?.images;

      dispatch(
        SelectedAssetData(!searchData ? response?.data?.data?.images : response?.data?.data?.files),
      );
      setIsLoading(false);

      dispatch(
        setInsideFolderFolderData({
          folders: [
            {
              id: insideFolderFolderData?.folders?.[0]?.id,
              folderName: insideFolderFolderData?.folders?.[0]?.folderName,
              subfolders: !searchData
                ? response?.data?.data?.folders?.[0]?.subfolders
                : (response?.data?.data?.folders ?? []),
            },
          ],
          images: !searchData ? response?.data?.data?.images : (response?.data?.data?.files ?? []),
        }),
      );

      dispatch(
        SetSelctedFoldersData(
          !searchData
            ? response?.data?.data?.folders?.[0]?.subfolders?.map((item) => ({
                ...item,
                isSelected: false,
                color: folder_related_color?.data?.data?.find((d) => d.folderId === item.id)?.color,
              }))
            : (response?.data?.data?.folders?.map((item) => ({
                ...item,
                isSelected: false,
                color: folder_related_color?.data?.data?.find((d) => d.folderId === item.id)?.color,
              })) ?? []),
        ),
      );

      setAssets((prev) => ({
        ...prev,
        folders: [{ id: damfieldid, subfolders: response?.data?.data ?? [] }],
      }));
    } catch (err) {
      setIsLoading(false);

      console.error(err);
    }
  };

  const handleSaveColor = async (Data, selectedColor) => {
    try {
      const result = await Axios.put(UPDATE_FOLDER_COLOR, {
        color: selectedColor?.hex,
        folderId: Data?.id,
      });
      toast.success(result?.data?.message);
      setActiveId(null);
      // HandleDelete();
      setOpenRightSection(false);
      getData(false);
      // setSelectedColor();
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (!showHeader) return;
    if (isFirstLoad) {
      dispatch(SelectedAssetData([]));
      dispatch(SetSelctedFoldersData([]));
      setIsFirstLoad(false);
      return;
    }
    const delaysearcfun = setTimeout(async () => {
      getData();
    }, 500);
    return () => clearTimeout(delaysearcfun);
  }, [searchData, refreshRef, trash, sorting]);

  useEffect(() => {
    if (isPoppedUp && assets?.folders?.[0]?.id) {
      setFolderId(assets?.folders?.[0]?.id); // Set the  folderId
      setCurrentModalFolderName(assets?.folders[0]?.folderName);
    }
  }, [isPoppedUp, assets]);

  const getLastSegment = (path) => {
    const parts = path.split('/').filter(Boolean); // split and remove empty values
    return parts[parts.length - 1]; // return last value
  };

  const handledownload = async (data) => {
    try {
      var _data = {
        fileId: [],
        folderId: [data?.id],
      };
      await startDownload(_data);
      setActiveId();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    let folderId = getLastSegment(location?.pathname);
    if (selectedfolderid?.length > 0) {
      folderId = selectedfolderid?.[selectedfolderid?.length - 1];
    }
    console.log(selectedfolderid, 'selectedfolderid');
    try {
      (async () => {
        setIsLoading(true);
        const splitat = trash === true ? 'bin/' : 'assets/';
        const multiarray_pathname = location?.pathname.split(splitat)[1];
        const response_data = await Axios.get(
          `${ROUTED_INNNER_FOLDER_DATA}?folderIds=${multiarray_pathname?.split('/')}`,
        );
        const multiarray_id_index = multiarray_pathname?.split('/');
        const ordered_folder_data = multiarray_id_index.map((id) =>
          response_data?.data?.data.find((item) => item.id === id),
        );
        setCurrentFolderDetails(ordered_folder_data?.[ordered_folder_data?.length - 1]);
        setInnerFolderData(ordered_folder_data);
        const subfolderData = await fetchSubfolders(folderId);

        const folderIds = subfolderData?.folders?.[0]?.subfolders?.map((folder) => folder?.id);

        const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);

        setnewfolder(folderId);

        if (metaData?.currentPage <= 0) {
          dispatch(
            SetSelctedFoldersData(
              subfolderData?.folders?.[0]?.subfolders?.map((item) => ({
                ...item,
                isSelected: false,
                color: folder_related_color?.data?.data?.find((d) => d.folderId === item.id)?.color,
              })),
            ),
          );
        }

        dispatch(setInsideFolderFolderData(subfolderData));
        setAssets(subfolderData);
        AddInArray(subfolderData);
        setImages(subfolderData?.images);
        const _combine_data =
          metaData?.currentPage > 0 || metaData?.isScrolling
            ? [...selectedAssets, ...(subfolderData?.images ? subfolderData?.images : [])]
            : subfolderData?.images;

        dispatch(SelectedAssetData(_combine_data));
        setIsLoading(false);
        // dispatch(se)
      })();
    } catch (err) {
      console.error(err);
    }
  }, [location?.pathname, metaData?.currentPage, selectedfolderid]);

  const onScroll = useCallback(() => {
    const el = listInnerRef.current;
    if (!el || isLoading || !isAvailableData) return;

    const { scrollTop, scrollHeight, clientHeight } = el;

    // Trigger slightly before bottom
    if (scrollTop + clientHeight >= scrollHeight - 1000) {
      setMetaData((prev) => {
        if (prev.isScrolling) return prev; // guard
        return {
          ...prev,
          currentPage: prev.currentPage + 1,
          isScrolling: true,
          external: 'no',
        };
      });
    }
  }, [isLoading, isAvailableData]);
  useEffect(() => {
    setScrollHandler(() => onScroll);
  }, [onScroll]);
  const title = passname;
  const toggledelete = () => setdeletemodal(!deletemodal);

  console.log(innerFolderData, 'innerFolderData');

  return (
    <>
      {deletemodal && (
        <Deletemodel
          deletemodal={deletemodal}
          toggledelete={toggledelete}
          handleDelete={handledelette}
          Header={`${trash ? 'Delete permanently' : 'Move to trash'}`}
          Content={`${trash ? `Are you sure you want to Delete?` : `Asset will be deleted after 30 days?`}`}
          loading={deleteLoading}
        />
      )}

      {movetoModal && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          Data={selectedDamFieldId}
          HandleAssetMove={() => {
            getData();
          }}
        />
      )}
      <Modal isOpen={upload} toggle={toggleupload} size="xl" style={{ width: '50%' }}>
        <ModalHeader toggle={toggleupload} close={closeBtn4}>
          {currentModalFolderName}
        </ModalHeader>
        <ModalBody className="">
          <Uploadfile
            loadedData={loadedData}
            totalData={totalData}
            disableDropBox={disableDropBox}
            uploadPercentage={uploadPercentage}
            uploadFiles={uploadFiles}
            files={files}
            setFiles={setFiles}
            previewFlag={previewFlag}
            setPreviewFlag={setPreviewFlag}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={modal} toggle={toggle} style={{ width: '50%' }}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Create Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label="Folder Name"
            name="textvalue"
            placeholder="Enter name of folder"
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC text="Close" click={() => setModal(false)} size="lg" color="Secondary" />

          <ButtonC text="Save" click={folderaddded} size="lg" />
        </ModalFooter>
      </Modal>

      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            click={() => setAddToCollectionModal(false)}
            size="lg"
            color="Secondary"
          />
          <ButtonC text="Save" click={folderedit} size="lg" />
        </ModalFooter>
      </Modal>

      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={[selectedDamFieldId]}
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
          shareType={0}
        />
      )}

      {showHeader && (
        <div
          className={`mt-2 div-width-print  ${isPoppedUp && 'flex justify-content-between text-center div-width-print'}`}
        >
          <div className={!isPoppedUp && 'textinner'}>
            {' '}
            <span
              className="pointer"
              onClick={() => {
                navigate('/dam/v2/assets');
              }}
            >
              Assets{' '}
            </span>
            {innerFolderData.map((item, index) => (
              <span className="pointer" onClick={() => handlenavigate(index)} key={index}>
                {/* <WordWrapEllipse Text={`/ ${item?.folderName}`} /> */}/{' '}
                {' ' + item?.folderName + ' '}
              </span>
            ))}
          </div>

          {isPoppedUp && <ButtonC size="lg" text="New Folder" click={toggle} />}
        </div>
      )}
      {selectedfolderid?.length > 0 && (
        <div>
          <button
            onClick={() =>
              setselectedfolderId((pre) => {
                const newpre = [...pre];
                newpre.pop();
                return newpre;
              })
            }
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 12px',
              background: '#f1f1f1',
              border: '1px solid #ddd',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 500,
              color: '#333',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#e6e6e6';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#f1f1f1';
            }}
          >
            ← Back
          </button>
        </div>
      )}
      <div
        className={`d-flex no-print justify-content-${!isPoppedUp ? 'between' : 'end'} ${isPoppedUp ? 'mt-2' : 'mt-5'}`}
      >
        <div className="d-flex align-items-center gap-3" style={{ justifyContent: 'center' }}>
          {!isPoppedUp && (
            <InputC
              type="Searchbar"
              placeholder="Search...."
              size="lg"
              name=""
              inputvalue={searchData}
              change={(e) => {
                setSearchData(e.target.value);
              }}
            />
          )}
        </div>

        {!isPoppedUp && (
          <div className="d-flex align-items-center gap-2">
            {false && (
              <div style={{ position: 'relative' }}>
                <h4
                  style={{
                    position: 'absolute',
                    bottom: '34px',
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  View
                </h4>
                <Viewbutton size="md" onSelectView={handleViewChange} />
              </div>
            )}

            {/* <ButtonC size="lg" text="New Folder" click={toggle} /> */}

            <div className="d-flex gap-2">
              {(selectedAssets?.filter((item) => item?.isSelected)?.length > 0 ||
                selectedFolders?.filter((item) => item?.isSelected)?.length > 0) &&
              !fromBrandAssets ? (
                <SelectionActions
                  handleDelete={() => {
                    // dispatch(setselectedas)
                    getData();
                    // getAllFolders();
                  }}
                  HandleAssetMove={() => {
                    getData();
                    // getAllFolders();
                  }}
                  trash={trash}
                />
              ) : (
                <div
                  className="d-flex justify-content-end relative"
                  style={{
                    position: 'relative',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <CommonTableDrived
                    Label="Sort By"
                    ClickedValue={(value) => {
                      setSorting(value);
                    }}
                    selectedValueData={sorting}
                    Option={sortOptions}
                  />
                  {(hasDAMFullAccess || isSelfAdd) &&
                    !fromBrandAssets &&
                    !trash && (
                      <CommonSidePortal
                        activeId={activeId}
                        setActiveId={setActiveId}
                        portalId={-1}
                        ViewSection={
                          <ButtonC size="lg" click={() => {}}>
                            <span className="d-flex gap-2 justify-content-center items-center text-center align-items-center">
                              {DAM_SVG?.additionIconSvg} Add
                            </span>
                          </ButtonC>
                        }
                        OpenSection={
                          <div className="openAdditionDialog">
                            <div
                              onClick={() => {
                                dispatch(
                                  setInnerFolderDetails(
                                    innerFolderData?.[innerFolderData?.length - 1],
                                  ),
                                );
                                dispatch(
                                  setInsideFolderFolderData(getLastSegment(location?.pathname)),
                                );
                                navigate('/dam/v2/uploads');
                              }}
                            >
                              {DAM_SVG.uploadSvgIcon} Asset Upload
                            </div>
                            <div onClick={toggle}>{DAM_SVG.addiitonSvgIcon} New Folder</div>
                          </div>
                        }
                      />
                    )}
                </div>
              )}
            </div>

            {/* <ButtonC size="lg" text="Upload" click={() => handleFolderClick(assets.folders[0].id)} /> */}

            {/* <ButtonC
              size="lg"
              text="Upload"
              click={() => handleFolderClick(assets.folders[0].id, assets.folders[0].folderName)}
            /> */}
          </div>
        )}
      </div>
      {isPoppedUp && isUpload && (
        <div className="mt-2">
          {' '}
          <Uploadfile
            loadedData={loadedData}
            totalData={totalData}
            disableDropBox={disableDropBox}
            uploadPercentage={uploadPercentage}
            uploadFiles={uploadFiles}
            files={files}
            setFiles={setFiles}
            previewFlag={previewFlag}
            setPreviewFlag={setPreviewFlag}
            isDropCircle={true}
          />
        </div>
      )}

      {isLoading ? (
        <SpinnerLoader />
      ) : (
        <div className="mt-3">
          {showFolders && selectedFolders?.length !== 0 && (
            <div>
              <div
                className="dis_grid grid_cols_5 "
                style={{
                  gap: '1rem',
                }}
              >
                {selectedFolders?.map((value, index) => (
                  <div lg={3} key={value.id}>
                    <FolderGridSecondVersion
                      trash={trash}
                      fromBrandAssets={fromBrandAssets}
                      Data={value}
                      Index={index}
                      Title={<WordWrapEllipse Text={value?.folderName} MaxWidth={'15ch'} />}
                      isFolder={true}
                      isSelected={
                        selectedFolders?.find((item, index) => item?.id === value?.id)?.isSelected
                      }
                      selectedfolderid={selectedfolderid}
                      HandleSelect={(data) => {
                        if (data?.Key === 4) {
                          handleClick(value?.id);
                          return;
                        }
                        if (data?.Key === 1) {
                          setPrevIndexSelected(value?.id);
                          const updatedValue = selectedFolders?.map((item) =>
                            item?.id === value?.id
                              ? { ...item, isSelected: !item?.isSelected }
                              : { ...item, isSelected: false },
                          );
                          dispatch(SetSelctedFoldersData(updatedValue));
                        } else if (data?.Key === 2) {
                          setPrevIndexSelected(value?.id);

                          const updatedValue = selectedFolders?.map((item) =>
                            item?.id === value?.id
                              ? { ...item, isSelected: !item?.isSelected }
                              : { ...item },
                          );

                          dispatch(SetSelctedFoldersData(updatedValue));
                        } else if (data?.Key === 3) {
                          const returnedValueData = selectRangeByUUID(
                            selectedFolders,
                            prevIndexSelected,
                            value?.id,
                            'id',
                          );
                          dispatch(SetSelctedFoldersData(returnedValueData));
                        }
                      }}
                      isEllipse={hasDAMAccess(MODULE_IDS.DAM)}
                      EllipseActions={(data) => {
                        const isSelf = hasDAMFullAccess ? true : data.isSelf;

                        return (
                          <CommonSidePortal
                            activeId={activeId}
                            setActiveId={setActiveId}
                            portalId={index}
                            ViewSection={<CommonThreeDotSvg />}
                            OpenSection={
                              trash === true ? (
                                <>
                                  {(isSelf || hasDAMAccess(MODULE_IDS.DAM)) && (
                                    <div
                                      className="d-flex align-items-center gap-2 pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setActiveId();

                                        setSelectedDamFieldId(value?.id);

                                        deletmodal(value?.folderName);
                                      }}
                                    >
                                      {' '}
                                      <img src={deleteicon} alt="deleteicon" />{' '}
                                      <p className="list_cart">
                                        {trash ? 'Delete' : 'Move to trash'}
                                      </p>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="">
                                  {(hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess]) ||
                                    isSelf) && (
                                    <div
                                      className="d-flex align-items-center gap-2 pointer"
                                      onClick={() => {
                                        setMovetoModal(true);
                                        setSelectedDamFieldId(value.id);
                                        setActiveId();
                                      }}
                                    >
                                      {DAM_SVG.moveAssetSvgIcon}
                                      <p className="list_cart">Move Folder</p>
                                    </div>
                                  )}
                                  {(isSelf || hasDAMAccess(MODULE_IDS.DAM)) && (
                                    <div
                                      className="d-flex align-items-center gap-2 pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setActiveId();

                                        setSelectedDamFieldId(value?.id);

                                        deletmodal(value?.folderName);
                                      }}
                                    >
                                      {' '}
                                      <img src={deleteicon} alt="deleteicon" />{' '}
                                      <p className="list_cart">
                                        {trash ? 'Delete' : 'Move to trash'}
                                      </p>
                                    </div>
                                  )}
                                  {/* {hasDAMAccess && ( */}
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActiveId();

                                      handledownload(value);
                                    }}
                                  >
                                    {' '}
                                    <img src={download} alt="downloadicon" />{' '}
                                    <p className="list_cart">Download</p>
                                  </div>
                                  {/* )} */}
                                  {(hasDAMAccess(MODULE_IDS.DAM) || isSelf) && (
                                    <div
                                      className="d-flex align-items-center gap-2 pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setActiveId();
                                        setSelectedDamFieldId(value?.id);

                                        settextvalue(value?.folderName);
                                        setAddToCollectionModal(!AddToCollectionModal);
                                      }}
                                    >
                                      <img src={renameicon} alt="renameicon" />
                                      <p className="list_cart">Rename</p>
                                    </div>
                                  )}
                                  {(hasDAMAccess(MODULE_IDS.DAM) || isSelf) && (
                                    <div
                                      className="p-relative"
                                      style={{
                                        position: 'relative',
                                      }}
                                    >
                                      <div
                                        className="d-flex justify-content-between align-items-center gap-2 pointer"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOpenRightSection(!openRightSection);
                                        }}
                                      >
                                        <div className="d-flex gap-2 align-items-center">
                                          {DAM_SVG.labelByColorSvgIcon}
                                          <p className="list_cart">Label By Color</p>
                                        </div>
                                        <div
                                          style={{
                                            paddingRight: '16px',
                                          }}
                                          onClick={(e) => {
                                            // e.stopPropagation();
                                            // setOpenRightSection(!openRightSection);
                                          }}
                                        >
                                          {DAM_SVG.rightSideSvgIcon}
                                        </div>
                                        {/* <img src={renameicon} alt="renameicon" /> */}
                                      </div>
                                      {openRightSection && (
                                        <div
                                          className="p-absolute cart_list"
                                          style={{
                                            position: 'absolute',
                                            left: '100%',
                                            padding: '16px',
                                          }}
                                        >
                                          <div className="color_heading">Folder Color</div>

                                          <div className="dis_grid grid_cols_5 gap-2">
                                            {selectionColors?.map((item) => (
                                              <div
                                                style={{
                                                  backgroundColor: item?.hex,
                                                  width: '32px',
                                                  height: '32px',
                                                  borderRadius: '50%',
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                }}
                                                onClick={() => {
                                                  handleSaveColor(value, item);
                                                }}
                                              >
                                                {' '}
                                                {value?.color === item?.hex &&
                                                  DAM_SVG.folderSelectTickIcon}
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {(isSelf || hasDAMFullAccess) && (
                                    <div
                                      className="d-flex align-items-center gap-2 pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        dispatch(setOpenPopup(value));
                                        setActiveId();
                                      }}
                                    >
                                      {' '}
                                      <img src={shareicon} alt="componenticon" />{' '}
                                      <p className="list_cart">Share</p>
                                    </div>
                                  )}
                                  {(isSelf || hasDAMAccess(MODULE_IDS.DAM)) && (
                                    <div
                                      className="d-flex align-items-center gap-2 pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();

                                        setActiveId();
                                        setSelectedDamFieldId(value?.id);
                                        handleshowdata(value?.id, 0);
                                      }}
                                    >
                                      {' '}
                                      {DAM_SVG.permissionSvg}
                                      <p className="list_cart">Invite Outside Org.</p>
                                    </div>
                                  )}
                                </div>
                              )
                            }
                            HandleEllipseClick={() => {
                              const updatedValue = selectedFolders?.map((item) =>
                                item?.id === value?.id
                                  ? { ...item, isSelected: !item?.isSelected }
                                  : { ...item, isSelected: false },
                              );

                              dispatch(SetSelctedFoldersData(updatedValue));
                            }}
                            Top={'15px'}
                            Right={'170px'}
                          />
                        );
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {showImages && (
            <div>
              <div className="mt-3">
                <div>
                  <div className="pt-1 pb-1">
                    {selectedView === 'Masonry View' && (
                      <Assitdata
                        trash={trash}
                        assets={insideFolderFolderData?.images?.map((item) => ({
                          ...item,
                          folderId: assets?.folders?.[0]?.id ?? insideFolderId ?? '',
                        }))}
                        datashow={getData}
                        show={show}
                        setAssets={setAssets}
                        collectionID=""
                        supportWebp={supportWebp}
                        showData={false}
                        showCopyLing={false}
                        showRenderActionButton={false}
                        fromBrandAssets={fromBrandAssets}
                      />
                    )}
                    {selectedView === 'Grid View' && (
                      <Griddata
                        trash={trash}
                        assets={insideFolderFolderData?.images}
                        datashow={datashow}
                        show={show}
                        setAssets={setAssets}
                        FolderselectAsset={FolderselectAsset}
                        supportWebp={supportWebp}
                        fromBrandAssets={fromBrandAssets}
                      />
                    )}
                    {selectedView === 'List View' && (
                      <Tabledata
                        trash={trash}
                        assets={insideFolderFolderData?.images}
                        setAssets={setAssets}
                        FolderselectAsset={FolderselectAsset}
                        supportWebp={supportWebp}
                        fromBrandAssets={fromBrandAssets}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {insideFolderFolderData?.folders?.[0]?.subfolders?.length === 0 &&
            selectedAssets?.length === 0 && (
              <div className=" d-flex align-item-center justify-content-center">
                <div className="w-50">
                  <Nodatacomponent />
                </div>
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default Innerfolder;
